var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisasterRisk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 82.861 78.803",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_16854",
    "data-name": "Group 16854",
    transform: "translate(-1272 -4577)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32472",
    "data-name": "Path 32472",
    d: "M34.253,2A19.253,19.253,0,1,0,53.506,21.253,19.253,19.253,0,0,0,34.253,2Z",
    transform: "translate(1257 4575)",
    fill: "#d6dcff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16804",
    "data-name": "Group 16804",
    transform: "translate(1281.481 4582.426)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32564",
    "data-name": "Path 32564",
    d: "M19.945,46.292a1.719,1.719,0,0,1-.71-.151,20.388,20.388,0,1,1,25.94-28.789,1.748,1.748,0,0,1-3.03,1.743,16.892,16.892,0,1,0-21.49,23.855,1.747,1.747,0,0,1-.71,3.343Z",
    transform: "translate(9.195 9.195)",
    fill: "#2a3d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32565",
    "data-name": "Path 32565",
    d: "M52.688,55.12H17.164a5.118,5.118,0,0,1-4.433-7.677L30.493,16.678a5.069,5.069,0,0,1,4.433-2.559h0a5.064,5.064,0,0,1,4.429,2.559L57.119,47.443a5.117,5.117,0,0,1-4.431,7.678ZM34.926,17.613a1.6,1.6,0,0,0-1.408.813L15.756,49.19a1.624,1.624,0,0,0,1.408,2.436H52.688a1.624,1.624,0,0,0,1.406-2.435L36.332,18.425a1.6,1.6,0,0,0-1.406-.812Z",
    transform: "translate(15.565 18.257)",
    fill: "#2a3d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32566",
    "data-name": "Path 32566",
    d: "M23,32.765a1.748,1.748,0,0,1-1.747-1.747V20.832a1.747,1.747,0,0,1,3.494,0V31.018A1.748,1.748,0,0,1,23,32.765Z",
    transform: "translate(27.487 24.678)",
    fill: "#2a3d57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32567",
    "data-name": "Path 32567",
    d: "M15.268,65.463a4.05,4.05,0,0,1-2.878-1.192L9.108,60.985a4.061,4.061,0,0,1,0-5.755l2.568-2.568a29.483,29.483,0,0,1-3.963-9.567H4.076A4.081,4.081,0,0,1,0,39.018V34.359a4.081,4.081,0,0,1,4.076-4.076h3.64a29.481,29.481,0,0,1,3.963-9.567L9.108,18.147a4.064,4.064,0,0,1,0-5.755l3.283-3.284a4.162,4.162,0,0,1,5.755,0l2.571,2.568a29.442,29.442,0,0,1,9.565-3.96V4.077A4.082,4.082,0,0,1,34.359,0h4.659a4.081,4.081,0,0,1,4.076,4.076v3.64a29.445,29.445,0,0,1,9.565,3.96L55.23,9.108a4.167,4.167,0,0,1,5.755,0l3.283,3.286a4.061,4.061,0,0,1,0,5.755L61.7,20.716a29.483,29.483,0,0,1,3.963,9.567H69.3a4.081,4.081,0,0,1,4.076,4.076v4.659A4.081,4.081,0,0,1,69.3,43.094H64.686a1.747,1.747,0,0,1,0-3.494H69.3a.59.59,0,0,0,.582-.582V34.359a.59.59,0,0,0-.582-.582H64.222A1.748,1.748,0,0,1,62.5,32.323a26.091,26.091,0,0,0-4.479-10.812,1.747,1.747,0,0,1,.189-2.247L61.8,15.676a.569.569,0,0,0,0-.812l-3.283-3.286a.5.5,0,0,0-.814,0l-3.587,3.588a1.75,1.75,0,0,1-2.247.189,26.1,26.1,0,0,0-10.812-4.477A1.747,1.747,0,0,1,39.6,9.155V4.077a.59.59,0,0,0-.582-.582H34.358a.59.59,0,0,0-.582.582V9.156a1.747,1.747,0,0,1-1.454,1.722A26.106,26.106,0,0,0,21.51,15.355a1.749,1.749,0,0,1-2.247-.189l-3.587-3.587a.5.5,0,0,0-.814,0l-3.283,3.284a.571.571,0,0,0,0,.812l3.59,3.588a1.747,1.747,0,0,1,.189,2.247,26.092,26.092,0,0,0-4.479,10.812,1.748,1.748,0,0,1-1.722,1.454H4.076a.59.59,0,0,0-.582.582v4.659a.59.59,0,0,0,.582.582H9.154a1.748,1.748,0,0,1,1.722,1.454,26.091,26.091,0,0,0,4.479,10.812,1.747,1.747,0,0,1-.189,2.247L11.579,57.7a.569.569,0,0,0,0,.812L14.862,61.8a.5.5,0,0,0,.814,0l3.587-3.588a1.745,1.745,0,0,1,2.241-.193,29.5,29.5,0,0,0,3.758,2.242,1.747,1.747,0,1,1-1.56,3.126A33.035,33.035,0,0,1,20.719,61.7l-2.573,2.573a4.043,4.043,0,0,1-2.878,1.193Z",
    fill: "#2a3d57"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1218",
    "data-name": "Ellipse 1218",
    cx: 1.747,
    cy: 1.747,
    r: 1.747,
    transform: "translate(48.754 61.007)",
    fill: "#2a3d57"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisasterRisk);
export default __webpack_public_path__ + "static/media/DisasterRisk.bc33f960fcca71f73e7f7965eacbdd34.svg";
export { ForwardRef as ReactComponent };